<!-- <ng-container> -->
<mat-table [dataSource]="dataSource" matSort cf2Spinner>
  <ng-container matColumnDef="{{ column }}" *ngFor="let column of columns; index as i" class="header-cell">
    <mat-header-cell *matHeaderCellDef disableClear="true" mat-sort-header>
      {{ listColumns[i][1].label }}
    </mat-header-cell>
    <mat-cell *matCellDef="let cell; index as j">
      <ng-container [ngSwitch]="listColumns[i][1].type">
        <ng-container *ngSwitchCase="'date'">
          <span [cf2DueDate]="{ date: cell[column], overdueBy: overdueDate }">
            {{ cell[column] | formattedDate }}
          </span>
        </ng-container>
        <ng-container *ngSwitchCase="'link'">
          <a (click)="selected.emit(cell)" class="is-linkable"> {{ cell[column] }}</a>
        </ng-container>
        <ng-container *ngSwitchCase="'text'">
          <span>{{ cell[column] }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'stringdate'">
          <!--{{ cell[column] | date: 'd-MMM-y' | uppercase }}-->
          {{ cell[column] | date: 'y-MM-dd' }} <!-- ISO-8601 date format -->
        </ng-container>
      </ng-container>
    </mat-cell>
  </ng-container>

  <!-- Header Row-->
  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>

  <!-- Detail Rows -->
  <mat-row *matRowDef="let cell; columns: columns"></mat-row>
</mat-table>
<!-- </ng-container> -->
<ng-container *transloco="let t;">
  @if (isInit && dataSource?.data?.length < 1) {
    <ng-container>
      <div class="noresult">
        <div>
          <center>
            <div style="margin-block: 3%;">
              {{ t('NoResultsFound') }}
            </div>
          </center>
        </div>
      </div>
    </ng-container>
  }
</ng-container>